import { UPDATE_ADMIN_COMMON_STATUS } from "@/store/mutation.type";
import Vue from "vue";
import Component from "vue-class-component";

@Component
export default class AdminCommonStatus extends Vue {
  get adminStatusStore() {
    return this.$store.state["admin-status"].status_store;
  }

  public getAdminCommonStatus(key: string) {
    return this.adminStatusStore[key];
  }

  public updateAdminCommonStatus(key: string, value: any) {
    this.$store.commit(UPDATE_ADMIN_COMMON_STATUS, { key, value });
  }
}
